/* This file was generated automatically. Do not edit manually. */

export enum LearningPath {
    FrontOfficeAgent = 'FrontOfficeAgent',
    FrontOfficeManager = 'FrontOfficeManager',
    Housekeeper = 'Housekeeper',
    HousekeepingManager = 'HousekeepingManager',
    ReservationsAgent = 'ReservationsAgent',
    ReservationsAndRevenueManager = 'ReservationsAndRevenueManager',
    GeneralManager = 'GeneralManager',
    PropertyAdministrator = 'PropertyAdministrator',
    FinanceManager = 'FinanceManager',
}
